exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Biziclick/bizisystem/src/app/main/menu-sidebar/menu-sidebar.component.css
// module id = ../../../../../src/app/main/menu-sidebar/menu-sidebar.component.css
// module chunks = main